import { useState } from "react";
import style from "./card.module.css"
import AppGetIcon from "../../../../common/UI/AppGetIcon";
import Card from "../../../../common/UI/Card";
import { Tooltip } from "react-tooltip";

const CardRoles = ({
  idRol,
  title,
  titlePosition,
  description,
  backgroundColor,
  titleColor,
  handleEdit,
  handleDelete, // <-- nuevo
  handlePermissions
}: PropsCardRoles) => {

  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredEdit, setIsHoveredEdit] = useState(false);
  const [isHoveredDelete, setIsHoveredDelete] = useState(false); // <-- nuevo estado

  const isBlocked = title.toLowerCase().includes('administrador') || title.toLowerCase().includes('docente') || title.toLowerCase().includes('estudiante');

  return (
    <div className={style.card}>
      <Card
        title={title}
        titlePosition={titlePosition}
        titlePadding="10px"
        backgroundColor={backgroundColor}
        titleColor={titleColor}
        footerContent={
          <div className={style.container_butoms}>
            <>
              <button
                className={`${style.footer_butom} ${isBlocked ? style.blocked : ''}`}
                onClick={handlePermissions}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                disabled={isBlocked}
                data-tooltip-id={'my-tooltip-trash'}
                data-tooltip-content={`Gestionar permisos`}
              >
                <Tooltip id="my-tooltip-trash" style={{ backgroundColor: "#41545C", color: "#FFFFFF", maxWidth: '500px', zIndex: 10, fontWeight: 'bold' }} />
                <AppGetIcon
                  name="clipboard-check"
                  fillColor={isBlocked ? "#CFCFCF" : "#1196ce"}
                  hoverColor={isHovered ? '#FFFFFF' : undefined}
                />
              </button>

              <button
                className={`${style.footer_butom} ${isBlocked ? style.blocked : ''}`}
                onClick={handleEdit}
                onMouseEnter={() => setIsHoveredEdit(!isBlocked)}
                onMouseLeave={() => setIsHoveredEdit(false)}
                disabled={isBlocked}
                data-tooltip-id={'my-tooltip'}
                data-tooltip-content={`Editar`}
              >
                <Tooltip id="my-tooltip" style={{ backgroundColor: "#41545C", color: "#FFFFFF", maxWidth: '500px', zIndex: 10, fontWeight: 'bold' }} />
                <AppGetIcon
                  name="pencil"
                  strokeColor={isBlocked ? "#CFCFCF" : "#1196ce"}
                  hoverColor={isHoveredEdit ? '#FFFFFF' : undefined}
                />
              </button>

              {handleDelete && (
                <button
                  className={`${style.footer_butom} ${isBlocked ? style.blocked : ''}`}
                  onClick={() => handleDelete(idRol)} // asegúrate de pasar el idRol correcto
                  onMouseEnter={() => setIsHoveredDelete(!isBlocked)}
                  onMouseLeave={() => setIsHoveredDelete(false)}
                  disabled={isBlocked}
                  data-tooltip-id={'my-tooltip-delete'}
                  data-tooltip-content={`Eliminar`}
                >
                  <Tooltip
                    id="my-tooltip-delete"
                    style={{ backgroundColor: "#41545C", color: "#FFFFFF", maxWidth: '500px', zIndex: 10, fontWeight: 'bold' }}
                  />
                  <AppGetIcon
                    name="trash"
                    strokeColor={isBlocked ? "#CFCFCF" : "#1196ce"}
                    hoverColor={isHoveredDelete ? '#FFFFFF' : undefined}
                  />
                </button>
              )}

            </>
          </div>
        }
      >
        <div className={style.container_body}>
          {description}
        </div>
      </Card>
    </div>
  )
};

export default CardRoles;
